import _OutboundOpportunityService from "../services/outbound-opportunity-service";
import { IOutboundOpportunityService } from "../types/services/outbound-opportunity-service";

const OutboundOpportunityService: IOutboundOpportunityService = new _OutboundOpportunityService();

export default OutboundOpportunityService;
